import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './BookingReportOptionsForm.html?raw';

import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import '../../../moreCore/UI/GenericDialog/GenericDialog';
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
class BookingReportOptionsForm extends compose(_WidgetBaseSP) {
    templateString: any = template;

    reportOptionsContainer: HTMLElement;
    categoriesContainer: HTMLElement;

    cbWithEvServ: MdsLax<InstanceType<typeof CheckBox>>;
    cbWithEvTask: MdsLax<InstanceType<typeof CheckBox>>;
    selectServiceCategory: MdsLax<InstanceType<typeof SearchSelect>>;
    selectTaskGroup: MdsLax<InstanceType<typeof SearchSelect>>;

    entityID: string
    data: {};

    displayOptionsDialog(url: string, ID: string, callback: (url: string, stringData: string) => void): void {

        this.entityID = ID;
        //let url = window.appRoot + "Downloads/ProjectReport";
        let dlg = new GenericDialog();
        dlg.enableContentOverflow(true);

        dlg.show(this.reportOptionsContainer, this.translations["BookingReportOptions_FormHeader"], null, null, "okcancel", (result) => {

            if (result != 1) {
                this.emit("bookingreport_cancelled");
                return;
            }

            let stringData = JSON.stringify(this.data);
            callback(url, stringData);
        })
    }

    private _onChange_General(): void {
        //let isEventOnly = this.cbOnlyEvents.getValue();
        let isWithEvServ = this.cbWithEvServ.getValue();
        let iswithEvTask = this.cbWithEvTask.getValue();

        //this.UiModder.domClass.toggle(this.categoriesContainer, "w3-disabled", isEventOnly);

        isWithEvServ ? this.selectServiceCategory.setReadonly(false) : this.selectServiceCategory.setReadonly(true);
        iswithEvTask ? this.selectTaskGroup.setReadonly(false) : this.selectTaskGroup.setReadonly(true);
        this.setData();
    }

    private setData(): void {

        this.data = {
            entityID: this.entityID,
            withEvServ: this.cbWithEvServ.getValue(),
            withEvTask: this.cbWithEvTask.getValue(),
            serviceCategory: this.selectServiceCategory.getValue(),
            taskGroup: this.selectTaskGroup.getValue()
        }
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);       

        this.setData();
        this.selectServiceCategory.loadListValues("--all--");
        this.selectTaskGroup.loadListValues("--all--");
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(BookingReportOptionsForm);